<template>
  <div class="main-wrapper party-edit">
    <v-container>
      <v-row>
        <v-col>
          <v-card>
            <v-card-title primary-title>
              ECO Portal Exports
            </v-card-title>
            <v-card-text>
              <v-row>
                <v-col>
                  <v-text-field
                    v-model="search"
                    append-icon="mdi-magnify"
                    label="Search"
                    single-line
                    clearable
                    hide-details
                  />
                </v-col>
              </v-row>
              <v-row>
                <v-col>
                  <v-data-table
                    :headers="headers"
                    :items="ecoPortalIntegrationExports"
                    class="elevation-0"
                    :items-per-page="15"
                    :loading="ecoPortalIntegrationApiLoading"
                    :search="search"
                  />
                </v-col>
              </v-row>
            </v-card-text>
          </v-card>
        </v-col>
      </v-row>
    </v-container>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'

import { INTEGRATION_NAMESPACE } from '@/store/integrations'

export default {
  name: 'ECOPortalExports',

  data () {
    return {
      headers: [
        {
          align: 'start',
          sortable: true,
          text: 'ID',
          value: 'id',
        },
        { sortable: true, text: 'Legal Case', value: 'legal_case.name' },
        { sortable: true, text: 'Created By', value: 'initiated_by.name' },
        { sortable: true, text: 'Created At', value: 'created_at' },
      ],

      search: '',
    }
  },

  computed: {
    ...mapGetters(INTEGRATION_NAMESPACE, [
      'ecoPortalIntegrationApiLoading',
      'ecoPortalIntegrationExports',
    ]),
  },

  created () {
    this.fetchEcoPortalExports()
  },

  methods: {
    ...mapActions(INTEGRATION_NAMESPACE, [
      'fetchEcoPortalExports',
    ]),
  },
}
</script>
